import {
    TOGGLE_SIDEBAR,
    HIDDEN_SIDEBAR,
    SHOW_SIDEBAR
} from "../../actions/types";

const initialState = {
    show: false
};

export default function(state = initialState, action) {
    const { type } = action;

    switch (type) {
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                show: !state.show
            };
        case HIDDEN_SIDEBAR:
            return {
                ...state,
                show: false
            };
        case SHOW_SIDEBAR:
            return {
                ...state,
                show: true
            };
        default:
            return state;
    }
}
